import styled, { css } from 'styled-components';

const tableLayoutStyles = css`
  width: 100%;
  margin: -10px 0 0;

  thead tr {
    border: none;
  }

  thead td,
  thead th {
    padding: 0;
    height: 40px;
  }
`;

export const AssigneeTableWrapper = styled.div`
  ${tableLayoutStyles}
`;

export const CheckoutEventsTableWrapper = styled.div`
  ${tableLayoutStyles}
`;
